const PageSizeSelector = ({ pageLimit, setPageLimit }) => {
  return (
    <div className="text-gray-600 text-sm">
      Show{" "}
      <select
        className="border rounded-md px-2 py-1"
        value={pageLimit}
        onChange={(e) => setPageLimit(Number(e.target.value))}
      >
        <option value={10}>10</option>
        <option value={24}>24</option>
        <option value={50}>50</option>
      </select>
    </div>
  );
};

export default PageSizeSelector;
